import React from 'react';
import PropTypes from 'prop-types';

import { Badge as StyledBadge } from './Badge.styled';

const Badge = (props) => <StyledBadge {...props} />;

Badge.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

Badge.defaultProps = {
  size: 'medium',
};

export default Badge;
